import axios from 'axios';

import { getCookie, setCookie } from '../../bundled_js/cookie_utils';
import { analyticsTrack, analyticsTrackRetry, isMobile } from '../../bundled_js/analytics_wrapper';


export default {
    methods: {
        async getIPData() {
            const apiKey = 'ee1c98bfac844278a953668b27afee0f';
            try {
                const ip = await axios.get('https://api.ipgeolocation.io/ipgeo?apiKey=' + apiKey);
                return ip.data;
            } catch(e) {
                Sentry.captureException(e);
                return '';
            }
        },
        getGDPROptInPreferences() {
            const cookie_preferences = getCookie('samsara_cookies');
            return {
                functionalOptIn: cookie_preferences.includes('fn'),
                analyticsOptIn: cookie_preferences.includes('an'),
                advertisingOptIn: cookie_preferences.includes('ad')
            }
        },
        trackFunnelStep(
            formType,
            url,
            locale,
            currentStep = 0,
            stepName = null,
            stepText = null,
            max,
            ip,
            flow,
            pageTitle,
            assetCount = null,
            assetType = null,
            fleetType = null,
            industry = null,
            features = null) {

            let properties = {
                form_type: formType,
                'page name': pageTitle,
                form_url: url,
                is_mobile: isMobile(),
                locale_site: locale,
                step_number: currentStep,
                step_name: stepName,
                step_text: stepText,
                flow: flow,
                'max steps': max,
                'ip address': ip,
                field_data: {
                asset_type: assetType,
                fleet_type: fleetType,
                size: assetCount,
                industry: industry,
                feature: features,
                },
            };
              if (currentStep === 0) {
                analyticsTrack('Form Started', {
                  form_type: formType,
                  form_url: url,
                  is_mobile: isMobile(),
                  locale_site: locale,
                });
              }else{
                analyticsTrack('Form Step Completed', properties);
              }
            if (assetCount) {
                let mpAssetCount = {"Asset Count": assetCount};
                analyticsTrack('free trial form step', {...properties, ...mpAssetCount});
            } else {
                analyticsTrack('free trial form step', properties);
            }
        },
        trackFunnelStepRetry(
            formType,
            url,
            locale,
            currentStep = 0,
            stepName = null,
            stepText = null,
            max,
            ip,
            flow,
            pageTitle,
            assetCount = null,
            assetType = null,
            fleetType = null,
            industry = null,
            features = null) {
                let properties = {
                    form_type: formType,
                    'page name': pageTitle,
                    form_url: url,
                    is_mobile: isMobile(),
                    locale_site: locale,
                    step_number: currentStep,
                    step_name: stepName,
                    step_text: stepText,
                    flow: flow,
                    'max steps': max,
                    'ip address': ip,
                    field_data: {
                    asset_type: assetType,
                    fleet_type: fleetType,
                    size: assetCount,
                    industry: industry,
                    feature: features,
                    },
                };
            if (currentStep === 0) {
                    analyticsTrackRetry('Form Started', {
                      form_type: formType,
                      form_url: url,
                      is_mobile: isMobile(),
                      locale_site: locale,
                    });
            }else{
                analyticsTrackRetry('Form Step Completed', properties);
            }
            if (assetCount) {
                let mpAssetCount = {"Asset Count": assetCount};
                analyticsTrackRetry('free trial form step', {...properties, ...mpAssetCount});
            } else {
                analyticsTrackRetry('free trial form step', properties);
            }
        },
        trackFleetAssessmentStep(step, max) {
            let properties = {
                'page_name' : document.title,
                'url' : window.location.pathname,
                'current_step' : step,
                'max_step': max
            }
            analyticsTrack('FA Step Viewed', properties);
        },
        trackFleetAssessmentSubmit() {
            let properties = {
                'page_name' : document.title,
                'url' : window.location.pathname
            }
            analyticsTrack('FA Submitted', properties);
        },
        trackFleetAssessmentPricingClick() {
          let properties = {
                'page_name' : document.title,
                'url' : window.location.pathname
            }
            analyticsTrack('FA Pricing Button Clicked', properties);
        },
        getUTMCookies() {
            const ATTRIBUTION_COOKIES = [
                "keyword",
                "utm_campaign",
                "utm_source",
                "utm_medium",
                "utm_content",
                "utm_term",
                "utm_ts",
                "utm_ext_ad_id",
                "utm_ext_adset_id",
                "utm_ext_campaign_id",
                "fpv",
                "referrer",
                "cid",
                "gclid",
                "_mkto_trk",
                "msclkid"
            ];

            return ATTRIBUTION_COOKIES
                .map(key => {
                    const cookie = {};
                    cookie['key'] = key;
                    cookie['value'] = getCookie(key);
                    return cookie;
                })
                .filter(cookie => cookie.value !== '');
        },
        getQuantcastID() {
            // The quantcast cookie needs to be set because it is used as orderId
            // in the tracking pixel on the thank you pages. The orderId is used
            // by quantcast for attribution.
            let quantcastID = getCookie('quantcast_id');
            if (!quantcastID) {
                // If the cookie doesn't exist we create a new value and store it
                quantcastID = (1 + Math.random()).toString(36).substr(2, 9);
                setCookie('quantcast_id', quantcastID, 90);
                return quantcastID;
            } else {
                // If the cookie is already defined, we return it
                return quantcastID;
            }
        },
        // getMixpanelID() {
        //     if (mixpanel && typeof(mixpanel.get_distinct_id) !== 'undefined') {
        //         try {
        //             // Add mixpanel_id so that we can use it to enrich leads
        //             const distinct_id = mixpanel.get_distinct_id();
        //             return distinct_id ? distinct_id : '';
        //         } catch(e) {
        //             Sentry.captureException(e);
        //         }
        //     }
        //     return ''
        // },
        getOptimizelyExperimentName() {
            return getCookie('optimizelyEndUserId');
        }
    }
};
